<template>
    <section :class="classes">
        <fieldset :class="mdsNS('form__checkbox-group')" role="group">
            <legend
                v-if="!showCheckAll && !!title"
                :class="mdsNS('form__checkbox-group-label')"
            >
                {{ title }}
            </legend>
            <markets-ui-checkbox
                v-if="showCheckAll"
                :namespaced="namespaced"
                :size="size"
                :label="title"
                :value="title"
                :checked="selectedAllState === 'all'"
                @change="handleClickAll"
            ></markets-ui-checkbox>
            <markets-ui-checkbox
                v-for="item in visibleDataModel"
                :namespaced="namespaced"
                :key="item.id"
                :label="item.name"
                :checked="item.selected"
                :value="item.id"
                :disabled="item.disabled"
                :size="size"
                @change="handleClickItem"
            ></markets-ui-checkbox>
        </fieldset>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-checkbox-group',
    mixins: [mixins],
    props: {
        title: String,
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        },
        size: {
            type: String,
            default: '',
            validator: function(value) {
                return !value || utils.inArray(['small', 'large'], value) > -1;
            }
        },
        isHorizontal: {
            type: Boolean,
            default: false
        },
        showCheckAll: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedAllState: 'indeterminate'
        };
    },
    computed: {
        classes() {
            const cls = [this.namespace()];
            if (this.size) {
                cls.push(this.namespace(`-${this.size}`));
            }
            if (this.isHorizontal) {
                cls.push(
                    this.mdsNS(
                        'form__field-group form__field-group--horizontal'
                    )
                );
            }
            cls.push(this.skinStyle);
            return cls;
        },
        checkboxData() {
            return utils.extend(true, [], this.dataModel);
        },
        visibleDataModel() {
            return this.dataModel.filter(item => item.visible);
        }
    },
    watch: {
        selectedAllState() {
            this.indeterminate();
        },
        dataModel: {
            handler(value) {
                const selected = value.filter(item => item.selected);
                if (selected.length === value.length) {
                    this.selectedAllState = 'all';
                } else if (selected.length === 0) {
                    this.selectedAllState = 'empty';
                } else {
                    this.selectedAllState = 'indeterminate';
                }
            },
            deep: true
        }
    },
    created() {
        this.namespace = utils.namespace('ui-checkbox-group', false);
    },
    mounted() {
        this.indeterminate();
    },
    methods: {
        indeterminate() {
            if (this.showCheckAll) {
                if (this.selectedAllState === 'indeterminate') {
                    this.$el.querySelector(
                        `[value='${this.title}']`
                    ).indeterminate = true;
                } else {
                    this.$el.querySelector(
                        `[value='${this.title}']`
                    ).indeterminate = false;
                }
            }
        },
        handleClickAll() {
            if (
                this.selectedAllState === 'empty' ||
                this.selectedAllState === 'indeterminate'
            ) {
                this.selectedAllState = 'all';
            } else {
                this.selectedAllState = 'empty';
            }
            const map = {};
            const state = this.selectedAllState === 'all' ? true : false;
            this.checkboxData.forEach(item => {
                item.selected = state;
                map[item.id] = state;
            });
            this.$emit('change', map);
        },
        handleClickItem(item) {
            const map = {};
            this.checkboxData.forEach(d => {
                if (d.id === item.value) {
                    map[d.id] = item.checked;
                    d.selected = item.checked;
                } else {
                    map[d.id] = d.selected;
                }
            });
            this.$emit('change', map);
        }
    }
};
</script>
